import {
  FETCH_DOCUMENTS_FAILURE,
  FETCH_DOCUMENTS_REQUEST,
  FETCH_DOCUMENTS_SUCCESS,
} from "../constants";

const INITIAL_STATE = {
  isLoading: false,
  documentList: [],
};

const myDocumentsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DOCUMENTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        documentList: [],
      };
    case FETCH_DOCUMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        documentList: action.payload,
      };
    case FETCH_DOCUMENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        documentList: [],
      };
    default:
      return state;
  }
};

export default myDocumentsReducer;
